module.exports = __webpack_public_path__ + "static/freePage-eec86a1f901cc8f86efa7e6807134a77.png";